import { defineComponent as _defineComponent } from 'vue'
import Suggestion from './Suggestion.vue';
    import { ProductInterface } from './models/SuggestionInterface.ts';

    interface SuggestionProps {
        suggestions: ProductInterface[];
        query: String;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Suggestions',
  props: {
    suggestions: { type: Array, required: true },
    query: { type: null, required: true }
  },
  emits: ['handleSetSuggestion'],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

    
    const emit = __emit;

    const setSuggestion = (suggestion) => {
        emit('handleSetSuggestion', suggestion);
    };

const __returned__ = { emit, setSuggestion, Suggestion }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})